import { Mail } from "lucide-react";
import { Link } from "react-router";

const GitHubIcon = ({ size = 18 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
    <path d="M9 18c-4.51 2-5-2-7-2" />
  </svg>
);

const LinkedInIcon = ({ size = 18 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect width="4" height="12" x="2" y="9" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

const PortfolioFooter = () => {
  return (
    <footer className="py-16 px-6 border-t border-border">
      <div className="max-w-4xl mx-auto text-center">
        <h3 className="font-serif text-xl font-semibold text-foreground mb-1">Tom Hudson</h3>
        <p className="text-sm text-muted-foreground mb-6">Strategic Services Director</p>

        <div className="flex justify-center gap-4 mb-8">
          <a href="https://github.com/tomrhudson" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="p-2.5 rounded-lg glass-card text-muted-foreground hover:text-foreground transition-colors">
            <GitHubIcon size={18} />
          </a>
          <a href="https://www.linkedin.com/in/hudsonthomas/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="p-2.5 rounded-lg glass-card text-muted-foreground hover:text-foreground transition-colors">
            <LinkedInIcon size={18} />
          </a>
          <a href="mailto:tom.r.hudson@pm.me" aria-label="Email" className="p-2.5 rounded-lg glass-card text-muted-foreground hover:text-foreground transition-colors">
            <Mail size={18} />
          </a>
        </div>

        <p className="text-xs text-muted-foreground">
          Built with an AI-queryable portfolio engine. Every claim is verifiable, every gap is disclosed.
          {" "}
          <Link to="/how-its-built" className="text-primary hover:underline">
            See how it's built
          </Link>
          .
        </p>
      </div>
    </footer>
  );
};

export default PortfolioFooter;
